import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
        <path
          d="M 20,100 L 20,25 L 35,25 L 50,44 L 65,25 L 80,25 L 80,100 L 65,100 L 65,50 L 50,70 L 35,50 L 35,100 L 20,100 Z"
          transform="translate(4.5, 10) scale(0.7, 0.57)"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
